// Homepage

// Collection Page - Displays the variant dropdown instead of adding to cart
$(document).on('click', '.variantSelect', function(e) {
  e.preventDefault();
  $(this).parents('.product-item__container').toggleClass('selectActive');
  $(this).parents('#AddToCartForm')
  .find('.product-details')
  .find('.select-container')
  .fadeIn({
    start: function () {
      $(this).css({
        display: "flex"
      });
    }
  });
});

$(document).on('click', '.selectClose', function(e) {
  e.preventDefault();
  $(this).parents('.product-item__container').toggleClass('selectActive');
  $(this).parents('#AddToCartForm')
  .find('.product-details')
  .find('.select-container')
  .fadeOut();
});